import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { ThemeProvider } from 'telia-front-react';
import LanguageStore from '../stores/LanguageStore';

interface Props {
  children?: React.ReactChild | React.ReactChild[];
  languageStore?: LanguageStore;
}

export const getIconPath = (name: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const req = require('@telia-front/icon/lib/svg/icons.svg');
  return req + name;
};

const DiilThemeProvider: React.FC<Props> = inject('languageStore')(
  observer((props: Props): JSX.Element => {
    return (
      <ThemeProvider locale={props.languageStore.currentLocale} brand="diil" getIconPath={getIconPath}>
        {props.children}
      </ThemeProvider>
    );
  })
);

export default DiilThemeProvider;
